import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "trigger", "dropdown", "search", "options"]
  static values = { placeholder: String }

  connect() {
    this.renderOptions()
    this.updateLabel()
  }

  toggle(event) {
    this.dropdownTarget.hidden = !this.dropdownTarget.hidden
    event.currentTarget.setAttribute("aria-expanded", String(!this.dropdownTarget.hidden))
    if (!this.dropdownTarget.hidden) this.searchTarget.focus()
  }

  filter() {
    const query = this.searchTarget.value.trim().toLocaleLowerCase()
    this.optionsTarget.querySelectorAll("[data-value]").forEach((option) => {
      option.hidden = !option.dataset.label.toLocaleLowerCase().includes(query)
    })
  }

  choose(event) {
    this.selectTarget.value = event.currentTarget.dataset.value
    this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.updateLabel()
    this.dropdownTarget.hidden = true
    this.element.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false")
    this.searchTarget.value = ""
    this.filter()
  }

  renderOptions() {
    this.optionsTarget.replaceChildren(...Array.from(this.selectTarget.options).filter((option) => option.value !== "").map((option) => {
      const button = document.createElement("button")
      button.type = "button"
      button.dataset.value = option.value
      button.dataset.label = option.text
      button.textContent = option.text
      button.className = "block w-full px-3 py-2 text-left text-sm text-slate-700 hover:bg-red-50 hover:text-red-700"
      button.addEventListener("click", (event) => this.choose(event))
      return button
    }))
  }

  updateLabel() {
    this.triggerTarget.textContent = this.selectTarget.selectedOptions[0]?.text || this.placeholderValue
  }

  close(event) {
    if (this.element.contains(event.target)) return

    this.dropdownTarget.hidden = true
    this.element.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false")
  }
}
